import React from 'react';

interface IProps {
  onSearch: (searchText: string) => void;
  searchPlaceholder: string;
}

export const SearchBar = ({ onSearch, searchPlaceholder }: IProps) => (
  <input
    id='servicesSearchBar'
    name='servicesSearchBar'
    type='text'
    className='h-[40px] w-[341px] bg-bw01 rounded pl-[14px] pr-[10px] py-[8px] text-bw08 placeholder-bw06 mt-[10px] border-[1px] outline-none  focus:border-bw06 border-bw04  '
    placeholder={searchPlaceholder}
    onChange={(e) => onSearch(e.target.value)}
  />
);
